/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOrganizationParentRequestDto
 */
export interface UpdateOrganizationParentRequestDto {
    /**
     * New parent organization ID or null to make it root
     * @type {string}
     * @memberof UpdateOrganizationParentRequestDto
     */
    parentId: string | null;
}

/**
 * Check if a given object implements the UpdateOrganizationParentRequestDto interface.
 */
export function instanceOfUpdateOrganizationParentRequestDto(value: object): value is UpdateOrganizationParentRequestDto {
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    return true;
}

export function UpdateOrganizationParentRequestDtoFromJSON(json: any): UpdateOrganizationParentRequestDto {
    return UpdateOrganizationParentRequestDtoFromJSONTyped(json, false);
}

export function UpdateOrganizationParentRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrganizationParentRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'parentId': json['parentId'],
    };
}

export function UpdateOrganizationParentRequestDtoToJSON(json: any): UpdateOrganizationParentRequestDto {
    return UpdateOrganizationParentRequestDtoToJSONTyped(json, false);
}

export function UpdateOrganizationParentRequestDtoToJSONTyped(value?: UpdateOrganizationParentRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parentId': value['parentId'],
    };
}

